module.exports = __webpack_public_path__ + "static/img/icon_xiandanmdds.37d5416f.png";